import { csColorAction } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  .order-templates-search {
    --cse-text-input-prefix-color: ${csColorAction.secondary};
  }
`
